import {
	AppShell
} from '@mantine/core';
import React, { useContext } from 'react';
import { Outlet } from 'react-router-dom';
import Footer from './components/layout/footer';
import Header from './components/layout/header';
import { SessionContext } from './context/SessionContext';

const Layout: React.FC = () => {
	const session = useContext(SessionContext);
	if (session === undefined) {
		throw new Error("Layout must be a child of sessionContext.");
	}

	return (
		<AppShell
			header={{ height: 50 }}
			footer={{ height: 32 }}
		>
			<AppShell.Header>
				<Header />
			</AppShell.Header>

			<AppShell.Main bg="blue">
				<Outlet />
			</AppShell.Main>

			<AppShell.Footer>
				<Footer />
			</AppShell.Footer>
		</AppShell>
	);
};

export default Layout;